<template>
  <a-layout class="main">
    <a-layout-sider width="0" class="bg-w no-fix-sider" >
      <a-menu :selectedKeys="selectKeys" mode="inline" class="menu-ul">
        <a-menu-item
          v-for="menu in menus"
          :key="menu.value"
          class="content-menu"
          :style="{'padding-right':badge&&menu.badge? '55px': '16px'}"
          @click="changeMenu"
        >
          <span class="name">{{ i18n ? $t(menu.label) : menu.label}}</span>
          <a-badge v-if="badge" class="badge1" :count="menu.badge"/>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <div v-resize="'x'"></div>
    <a-layout-content class="content1">
      <slot name="right"/>
    </a-layout-content>
  </a-layout>
</template>

<script>
export default {
  name: 'SplitContent',
  props: {
    i18n: {
      type: Boolean,
      default: false
    },
    badge: {
      type: Boolean,
      default: false
    },
    menus: {
      type: Array
      // default: [{ badge: '', label: '', value: '' }] ,badge为徽标值,若没有徽标可不传
    },
    selectKeys:{
      type:Array,
      default: () => ([])
    }
  },
  data () {
    return {
      defaultSelectedKeys: []
    }
  },
  watch: {
    menus: {
      handler (newValue, oldValue) {
        if (newValue && newValue.length) {
          this.defaultSelectedKeys.push(newValue[0].value)
          this.$emit('changeItem', newValue[0])
        }
      },
      immediate: true
    }
  },
  methods: {
    changeMenu (menuItem) {
      let selectedItem = this.menus.find(item => item.value === menuItem.key)
      console.log(selectedItem,'aaaaaaaa')
      this.$emit('changeItem', selectedItem)
    }
    
  },
  mounted() {
    if(this.$route.path == '/material/basics/statisticalReport/stock') {
      this.selectKeys = 'inventoryStatistics'
      this.defaultSelectedKeys = [ 'inventoryStatistics']
      this.$emit('changeItem', {
        label: "page_meterial_inventory_tatistics",
        value: "inventoryStatistics"
      })
    }
    else if(this.$route.path == '/material/basics/statisticalReport/record') {
      this.selectKeys =  'analysisSetting'
      this.defaultSelectedKeys = [ 'analysisSetting']
      this.$emit('changeItem', {
        label: "page_meterial_analysis_setting",
        value: "analysisSetting"
      })
    }

    console.log(this.menus,this.selectKeys,this.defaultSelectedKeys,'ababababa')
  }
}
</script>

<style scoped lang="less">
  .main {
    background: #fff;
    height: 100%;

    .bg-w {
      background-color: #fff;
      box-shadow: none !important;
      border: none!important;
    }
  }

  .menu-ul {
    padding-top: 12px;
    height: 100%;
  }

  .content-menu {
    position: relative;
    padding-right: 55px;

    span.name {
      font-size: 16px;
      vertical-align: middle;
      min-width: 120px;
      display: inline-block;
    }
  }

  .badge1 {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%)
  }

  .content1 {
    height: 100%;
    background-color: #fff;
  }
</style>
